/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
// import { AccountsContext } from 'AccountsContext'
import './EmailVerification.css'
import { isEmpty, sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'

import { SVGComponent } from '../../../newComponents'
import {
  getUserProfileDetails,
  getLinkedEmailsList,

} from '../../../pages/Trips/trips.helper'
import USER_PROFILE_PAGE_CONSTANTS from '../../../newComponents/UnifiedLogin/UserProfileConstants'
import useModal from '../../../newComponents/SupportPage/useModal'
import { ViewContainer } from '../../../newComponents/UnifiedLogin'

const EmailVerification = ({ isVerified }) => {
  const [userdetails, setUserDetails] = useState('')
  const [countryCode, setCountryCode] = useState('+91')
  // const { emailSent } = useContext(AccountsContext)
  const [page, setPageName] = useState(null)
  const { isShowing, toggle } = useModal()
  const [emailsLinkedInTrips, setEmailsLinkedInTrips] = useState([])
  const [apiUserName, setApiUsername] = useState('')

  const handleIsShowing = () => {
    // setPageName('EMAIL_LINKED')
    // setButtonClicked(false)
    toggle()
  }

  const handleClick = async () => {
    const payload = {
      userdetails,
      countryCode
    }
    ClevertapEvent({
      action_name: 'add_email_clicked',
      page_name: 'my_trips',
      platform: 'Desktop',
      is_logged_in: 'Yes',
      domainName: window && window.location.hostname
    })
    const res = await getLinkedEmailsList(payload)
    const { status, data } = res || {}
    if (status === 200 && !isEmpty(data)) {
      setEmailsLinkedInTrips(data)
      setPageName(USER_PROFILE_PAGE_CONSTANTS.EMAIL_LINKED)
    } else {
      setPageName(USER_PROFILE_PAGE_CONSTANTS.PERSONAL_DETAILS)
    }
    toggle()
  }

  const setUserProfileDetails = async () => {
    try {
      const response = await getUserProfileDetails()
      const { status, data } = response || {}
      if (status === 200) {
        // const { mobile } = data
        const { username, mobile, countryCode } = data
        // setUsername(username)
        if (mobile) {
          setUserDetails(mobile)
          setCountryCode(countryCode)
          setApiUsername(username)
        } else {
          setUserDetails(mobile)
          setCountryCode(countryCode)
          setApiUsername(username)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    setUserProfileDetails()
  }, [])

  return (
    <React.Fragment>
      <If condition={!apiUserName}>
        <ul
          className="contact_support m-4 verify-account"
          style={{ height: 123, width: 261, backgroundColor: '#EFF5FC' }}
        >
          <li className="p-3 pb-3 flex">
            <div className="flex flex-column flex-center fs-13">
              <SVGComponent svgIcon="emailSvg" />
              <span
                className="ta-l us-text fw-500 mt-2"
                style={{ color: '#1A1A1A' }}
              >
                Add your e-mail <br />
              </span>
              <span style={{ color: '#4D4D4D' }}>
                and get access to your previous trips.
              </span>
              <a
                onClick={() => handleClick()}
                className="verify-account-link us-text"
              >
                Add now
              </a>
            </div>
          </li>
        </ul>
      </If>

      <ViewContainer
        emailsLinkedInTrips={emailsLinkedInTrips}
        page={page}
        isShowing={isShowing}
        toggle={toggle}
        handleIsShowing={handleIsShowing}
      />
    </React.Fragment>
  )
}

export default EmailVerification
